<template>
  <div class="knowledge_wrap">
    <div v-if="knowledge_first_list.length" class="knowledge_list">
      <template v-for="(k, i) in knowledge_first_list">
        <div class="knowledge_first" :key="k.sid">
          <div class="first_cont" @click="handleKnowledge(k.sid)">
            <img
              :class="default_knowledge_id == k.sid ? '' : ''"
              :src="
                default_knowledge_id == k.sid
                  ? require('@/assets/home/down.png')
                  : require('@/assets/home/right.png')
              "
              alt=""
            />
            <p>第{{ i + 1 }}章 {{ k.name }}</p>
          </div>

          <div v-if="default_knowledge_id == k.sid" class="knowledge_second">
            <div
              v-for="(kk, kk_i) in knowledge_second_list"
              class="secont_cont"
              :key="kk.sid"
            >
              <p>
                {{ i + 1 }}.{{ kk_i + 1 }}
                {{ kk.name }}
              </p>
              <div class="k_r">
                <!-- <span>
                  {{ handleFilterUser(keys) }} /{{
                    filter_knowledge_name(values, "nums")
                  }}
                </span> -->
                <template v-if="is_login">
                  <!-- <router-link
                    v-if="filter_knowledge_name(values, 'nums') == 0"
                    to=""
                  >
                    <div class="topractice tac" @click="handleNumClear">
                      练习
                    </div>
                  </router-link> -->
                  <router-link
                    :to="`/know_answer/${major_id}/${kk.sid}/${k.sid}`"
                    target="_blank"
                  >
                    <div class="topractice tac">练习</div>
                  </router-link>
                </template>
                <template v-else>
                  <div class="topractice tac" @click="handleToLogin">练习</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-else class="knowledge_list">
      <nocontent />
    </div>
  </div>
</template>

<script>
import api from "@/request/api";
import { toLogin } from "@/assets/js/cookie.js";
import nocontent from "@/components/nocontent.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { nocontent },
  props: {
    major_id: String,
    subject_id: String,
    is_login: Boolean,
    tag: String,
  },
  data() {
    //这里存放数据
    return {
      knowledge_first_list: [],
      default_knowledge_id: null,
      knowledge_second_list: [],

      user_know: {},
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    major_id(newVal, oldVal) {
      if (newVal) {
        this.getKnowledge();
      }
    },
    subject_id(newVal, oldVal) {
      if (newVal) {
        this.getKnowledge();
      }
    },
  },
  //方法集合
  methods: {
    async getKnowledge(knowledge_id) {
      try {
        const res = await api.knowledge({
          major_id: this.major_id,
          subject_id: this.subject_id,
          knowledge_id: knowledge_id,
        });
        if (res.code == 0) {
          let { first } = res.result;
          if (first && first.length) {
            if (this.tag == "home") {
              this.knowledge_first_list = first.slice(0, 8);
            } else {
              this.knowledge_first_list = first;
              this.default_knowledge_id = first[0].sid;
              this.getSecond(this.default_knowledge_id);
            }
          } else {
            this.knowledge_first_list = [];
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleKnowledge(id) {
      this.knowledge_second_list = [];
      if (this.default_knowledge_id) {
        if (this.default_knowledge_id == id) {
          this.default_knowledge_id = null;
        } else {
          this.default_knowledge_id = id;
          this.getSecond(id);
        }
      } else {
        this.default_knowledge_id = id;
        this.getSecond(id);
      }
    },
    async getSecond(knowledge_id) {
      try {
        const res = await api.second({
          major_id: this.major_id,
          knowledge_id: knowledge_id,
        });
        if (res.code == 0) {
          let { second_knowledge, user_knowledge } = res.result;
          this.knowledge_second_list = second_knowledge;
          this.user_know = user_knowledge;
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleToLogin() {
      toLogin(location.href);
    },
    handleNumClear() {
      this.$message.warning("该知识点下没有可以练习的题目啦");
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getKnowledge();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
.knowledge_list {
  position: relative;
  min-height: 400px;
  .knowledge_first {
    // margin-top: 10px;
    // height: 54px;
  }
  .first_cont {
    height: 54px;
    display: flex;
    padding-left: 20px;
    cursor: pointer;
    img {
      margin-right: 20px;
      transition: 1s;
      transform-origin: center;
      transform: rotateZ(0deg);
      width: 24px;
      height: 24px;
      margin-top: 14px;
    }
    .arrowTransformReturn {
      transition: 1s;
      transform-origin: center;
      transform: rotateZ(90deg);
    }
    & > p {
      font-size: 18px;
      font-weight: bold;
      color: #1f1f1f;
      line-height: 54px;
    }
  }
  .knowledge_second {
    position: relative;
    // padding-left: 44px;
    .secont_cont {
      margin-top: 10px;
      padding-left: 64px;
      padding-right: 20px;
      height: 56px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > p {
        font-size: 18px;
        color: #4f5666;
        flex: 1;
        overflow: hidden;
      }
      .k_r {
        display: flex;
        align-items: center;
        span {
          font-size: 16px;
          font-weight: 400;
          color: #4f5666;
          margin-right: 48px;
        }
        .topractice {
          width: 80px;
          height: 36px;
          border: 1px solid #479dff;
          border-radius: 18px;
          font-size: 16px;
          font-weight: 400;
          color: #479dff;
          line-height: 36px;
          cursor: pointer;
        }
      }
    }
    .secont_cont:hover {
      background: #f3f8fb;
      .topractice {
        background: #479dff;
        color: #fff;
      }
    }
  }
}
</style>
